import { createFileRoute } from '@tanstack/react-router';

import { NoMoreTasksToValidate } from '@/features/agents';

export type ShowPanelType = 'agent-runs' | 'email';

export const Route = createFileRoute('/_auth/details/agents/$agentId/empty')({
  component: NoMoreTasksToValidate,
});
